import ShareIcon from './shareIcon.svg';
import FacebookShareIcon from './facebookShareIcon.svg';
import LinkedinShareIcon from './linkedinShareIcon.svg';
import CopyShareIcon from './copyShareIcon.svg';
import EmailShareIcon from './emailShareIcon.svg';

export {
  ShareIcon,
  FacebookShareIcon,
  LinkedinShareIcon,
  CopyShareIcon,
  EmailShareIcon,
};
